var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M9.001 10.978H5.75a.751.751 0 0 1-.544-1.27l6.069-6.396a.998.998 0 0 1 1.45 0l6.068 6.396a.752.752 0 0 1-.543 1.27h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"}));
}

ArrowUp.defaultProps = {"fill":"currentColor","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","clipRule":"evenodd","viewBox":"0 0 24 24"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
